module.exports = __webpack_public_path__ + "img/olas_celestes.c9c9aee2.png";